import { IDonation, IFundableProject } from '@nibtravel/shared/util/models';

export interface IFootprintsState {
  donations: IDonation[];
  fundableProjects: IFundableProject[];
}

export const defaultFootprintsState: IFootprintsState = {
  donations: [],
  fundableProjects: [],
};
